// Keep these locale identifiers aligned with the viewer and Experiences API.
export const LOCALE_STORAGE_KEY = "10k.localization.locale";
export const LOCALE_DETAILS = Object.freeze([
  { locale: "en", nativeName: "English" },
  { locale: "es-419", nativeName: "Español (Latinoamérica)" },
  { locale: "ar", nativeName: "العربية" },
  { locale: "zh-CN", nativeName: "简体中文" },
  { locale: "vi", nativeName: "Tiếng Việt" },
  { locale: "pt-BR", nativeName: "Português (Brasil)" },
  { locale: "tr", nativeName: "Türkçe" },
  { locale: "fr", nativeName: "Français" },
  { locale: "it", nativeName: "Italiano" },
  { locale: "de", nativeName: "Deutsch" },
  { locale: "ru", nativeName: "Русский" },
  { locale: "hi", nativeName: "हिन्दी" },
]);
export const SUPPORTED_LOCALES = Object.freeze(LOCALE_DETAILS.map(({ locale }) => locale));

export function findSupportedLocale(value) {
  const normalized = String(value ?? "").trim().replaceAll("_", "-").toLowerCase();
  if (/^zh(?:-cn|-sg|-hans(?:-.*)?)?$/.test(normalized)) return "zh-CN";
  if (/^pt(?:-br(?:-.*)?)?$/.test(normalized)) return "pt-BR";
  if (/^es(?:-.*)?$/.test(normalized)) return "es-419";
  return ["en", "ar", "vi", "tr", "fr", "it", "de", "ru", "hi"]
    .find((locale) => normalized === locale || normalized.startsWith(`${locale}-`)) ?? null;
}

export const normalizeLocale = (value) => findSupportedLocale(value) ?? "en";

export function getInitialBrowserLocale() {
  try {
    const saved = findSupportedLocale(window.localStorage.getItem(LOCALE_STORAGE_KEY));
    if (saved) return saved;
  } catch { /* Storage may be disabled. The in-memory selection still works. */ }
  const languages = typeof navigator === "undefined" ? [] : navigator.languages?.length
    ? navigator.languages : [navigator.language];
  return languages.map(findSupportedLocale).find(Boolean) ?? "en";
}
